// extracted by mini-css-extract-plugin
export default {"generalWallboard":"style_generalWallboard__KXypz","generalWallboardCaptionContainer":"style_generalWallboardCaptionContainer__ERAd9"};